import {
  BufferTrackerReact as BufferTracker,
  Client,
  Product,
} from '@buffer-mono/tracking-plan'
import { useCommonTrackingProperties } from '~publish/hooks/useCommonTrackingProperties'

type TrackTemplateFiltered = {
  filterType: 'category' | 'madeFor' | 'format' | 'goal'
  filterValue: string
}

export const useTemplateTracking = () => {
  const commonTrackingProperties = useCommonTrackingProperties()

  const trackTemplateFiltered = ({
    filterType,
    filterValue,
  }: TrackTemplateFiltered): void => {
    BufferTracker.templateFilterClicked({
      clientName: Client.PublishWeb,
      product: Product.Publish,
      filterType,
      filterValue,
      ...commonTrackingProperties,
    })
  }

  return {
    trackTemplateFiltered,
  }
}
